
import React, { useState } from 'react';
import {
    Paper,
    Button,
    IconButton,
    Typography,
    Box,
    Dialog,
    TextField,
    Chip,
} from '@material-ui/core';
import { Autocomplete } from "@material-ui/lab";
import { makeStyles } from '@material-ui/core/styles';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import CancelIcon from '@material-ui/icons/Cancel';
import GTLabel from "components/GTLabel";

const BRAND = {
    darkPurple: 'rgb(79, 45, 127)',
};

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3),
        maxWidth: 920,
    },
    header: {
        color: BRAND.darkPurple,
        fontWeight: 100,
        marginBottom: theme.spacing(2),
        textAlign: 'center',
    },
    iterationPaper: {
        background: 'rgba(160,109,255,0.06)',
        borderRadius: 12,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(2.5),
        position: 'relative',
    },
    addIteration: {
        position: 'absolute',
        right: 16,
        top: 12,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        color: BRAND.darkPurple,
    },
    chipContainer: {
        marginTop: theme.spacing(2),
        display: 'flex',
        gap: theme.spacing(1),
        flexWrap: 'wrap',
        flexDirection: "row",
        width: "400px",
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    submitBtn: {
        background: BRAND.darkPurple,
        color: 'white',
        padding: theme.spacing(1, 3),
        borderRadius: 10,
        textTransform: 'none',
        '&:hover': {
            background: BRAND.darkPurple,
            color: 'white',
        },
    },
    cancelBtn: {
        background: 'white',
        color: BRAND.darkPurple,
        padding: theme.spacing(1, 3),
        borderRadius: 10,
        textTransform: 'none',
        border: `1px solid ${BRAND.darkPurple}`,
    },
    removeBtn: {
        position: 'absolute',
        left: 16,
        top: 12,
        color: BRAND.darkPurple,
    },
}));

const gstinList = [
    { gstin: "10AAAFW4298E1Z0" },
    { gstin: "07AAACB1234C1Z1" }
];

const emailList = [
    { email: "abc@example.com" },
    { email: "xyz@example.com" },
    { email: "test@example.com" },
    { email: "hello@example.com" }
];

export default function NewEmailConfiguration({ open, onClose }) {
    const classes = useStyles();

    const [iterations, setIterations] = useState([
        {
            selectedGstin: '',
            gstinInputValue: '',
            selectedEmails: [],
            inputValue: ''
        }
    ]);

    const [searchTerm, setSearchTerm] = useState("");
    const [gstinSearchTerm, setGstinSearchTerm] = useState("");

    const addIteration = () => {
        setIterations(prev => [
            ...prev,
            {
                selectedGstin: '',
                gstinInputValue: '',
                selectedEmails: [],
                inputValue: ''
            }
        ]);
    };

    const removeIteration = (index) => {
        setIterations(prev => prev.filter((_, i) => i !== index));
    };

    const handleEmailSelect = (index, value) => {
        setIterations(prev => {
            const updated = [...prev];
            if (value && !updated[index].selectedEmails.includes(value)) {
                updated[index].selectedEmails.push(value);
                updated[index].inputValue = "";
            }
            return updated;
        });
    };

    const handleChipDelete = (index, chipIndex) => {
        setIterations(prev => {
            const updated = [...prev];
            updated[index].selectedEmails.splice(chipIndex, 1);
            return updated;
        });
    };

    const handleInputChange = (index, newInputValue) => {
        setIterations(prev => {
            const updated = [...prev];
            updated[index].inputValue = newInputValue;
            return updated;
        });
    };

    const handleGstinInputChange = (index, newInputValue) => {
        setIterations(prev => {
            const updated = [...prev];
            updated[index].gstinInputValue = newInputValue;
            return updated;
        });
    };

    const handleGstinSelect = (index, newValue) => {
        setIterations(prev => {
            const updated = [...prev];
            updated[index].selectedGstin = newValue;
            updated[index].gstinInputValue = "";
            return updated;
        });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const payload = iterations
            .map(it => ({
                gstin: it.selectedGstin,
                emails: it.selectedEmails
            }))
            .filter(p => p.gstin || p.emails.length > 0);

        // Optional: remove iterations with no gstin and no emails
        const filtered = payload.filter(p => p.gstin || (p.emails && p.emails.length > 0))
        console.log('payload', payload);
        alert('Payload logged to console');
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                style: { width: '40%', height: "47%" }
            }}
        >
            <Paper className={classes.root} elevation={0}>
                <Typography variant='h6' className={classes.header}>
                    New Email Configuration
                </Typography>

                <form onSubmit={onSubmit}>
                    {iterations.slice(0, 10).map((it, idx) => (
                        <Box key={idx} className={classes.iterationPaper}>
                            {iterations.length > 1 && (
                                <IconButton
                                    size='small'
                                    className={classes.removeBtn}
                                    onClick={() => removeIteration(idx)}
                                >
                                    {/* <CloseIcon /> */}
                                </IconButton>
                            )}

                            <div
                                className={classes.addIteration}
                                onClick={addIteration}
                                title='Add Iteration'
                            >
                                <AddCircleOutlineIcon />
                                <Typography style={{ marginLeft: 6 }}>
                                    Add Iteration
                                </Typography>
                            </div>

                            <div className='new-config-dropdownSection'>

                                <div className="newconfig-dropdown" style={{ width: "52%" }}>
                                    <GTLabel
                                        title="GSTIN"
                                        style={{
                                            fontFamily: "GT-Walsheim-medium",
                                            fontSize: "12px"
                                        }}
                                    />
                                    <Autocomplete
                                        disableClearable
                                        options={gstinList
                                            .map(item => item.gstin)
                                            .filter(gstin =>
                                                gstin.toLowerCase().includes(gstinSearchTerm.toLowerCase())
                                            )
                                        }
                                        value={it.selectedGstin}
                                        inputValue={it.gstinInputValue}
                                        onInputChange={(e, val) =>
                                            handleGstinInputChange(idx, val)
                                        }
                                        onChange={(e, val) =>
                                            handleGstinSelect(idx, val)
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select"
                                                variant="outlined"
                                                size="small"
                                                style={{
                                                    backgroundColor: "white",
                                                    borderRadius: "4px"
                                                }}
                                            />
                                        )}
                                    />
                                </div>


                                <div className="newconfig-dropdown" style={{ width: "52%" }}>
                                    <GTLabel
                                        title="Select Email"
                                        style={{
                                            fontFamily: "GT-Walsheim-medium",
                                            fontSize: "12px"
                                        }}
                                    />
                                    <Autocomplete
                                        options={emailList
                                            .map(item => item.email)
                                            .filter(email =>
                                                !it.selectedEmails.includes(email) &&
                                                email.toLowerCase().includes(searchTerm.toLowerCase())
                                            )
                                        }
                                        value={null}
                                        inputValue={it.inputValue}
                                        onInputChange={(e, val) =>
                                            handleInputChange(idx, val)
                                        }
                                        onChange={(e, val) =>
                                            handleEmailSelect(idx, val)
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select"
                                                variant="outlined"
                                                size="small"
                                                style={{
                                                    backgroundColor: "white",
                                                    borderRadius: "4px"
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>


                            {it.selectedEmails.length > 0 && (
                                <div
                                    style={{
                                        marginTop: "12px",
                                        padding: "8px",
                                        backgroundColor: "#F9F5FF",
                                        borderRadius: "6px",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "8px"
                                    }}
                                >
                                    {it.selectedEmails.map((email, i) => (
                                        <Chip
                                            key={i}
                                            label={email}
                                            clickable
                                            deleteIcon={
                                                <CancelIcon style={{ color: "rgb(79, 45, 127)" }} />
                                            }
                                            color="secondary"
                                            style={{
                                                backgroundColor: "#f9f5ff",
                                                color: "#4f2d7f",
                                                border: "1px solid #4f2d7f",
                                                fontSize: "12px"
                                            }}
                                            onDelete={() => handleChipDelete(idx, i)}
                                        />
                                    ))}
                                </div>
                            )}
                        </Box>
                    ))}

                    <div className={classes.footer}>
                        <Button className={classes.submitBtn} type='submit'>
                            Submit
                        </Button>
                        <Button
                            className={classes.cancelBtn}
                            type='button'
                            onClick={onClose}
                        >
                            Cancel
                        </Button>
                    </div>
                </form>
            </Paper>
        </Dialog>
    );
}
